export enum QueryKey {
  BUSINESSES_INFO = "businesses_info",
  BUSINESSES_TRANSACTIONS = "businesses_transactions",
}
